const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/registerstudentpay/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/registerstudentpay/homepage/index.js